export const boxThemeToTailwindClasses = (theme: any) => {
    const classes = Array.isArray(theme?.tailwindClasses)
        ? [...theme?.tailwindClasses]
        : [];
    if (
        !classes?.includes("bg-cover") &&
        !classes?.includes("bg-contain") &&
        !classes?.includes("bg-auto")
    ) {
        classes.push("bg-cover");
    }

    return [
        ...classes,
        "h-fit",
        "w-full",
        "min-h-full",
        "bg-transparent",
        "relative",
    ];
};
